
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

const ValuePropositionSection = () => {
  return (
    <section className="section-padding bg-white">
      <div className="container-custom">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          <div className="order-2 md:order-1">
            <h2 className="text-2xl md:text-3xl font-medium mb-6">Unikaalne väärtuspakkumine</h2>
            
            <div className="space-y-6">
              <div className="bg-kaija-light p-6 rounded-lg shadow-sm">
                <h3 className="text-lg font-medium mb-2">Isiklik ja tähenduslik lähenemine</h3>
                <p className="text-gray-700">
                  Iga coaching'u teekond on ainulaadne – kohandan selle vastavalt sinu vajadustele ja olukorrale, et toetada sinu sisemist arengut ja isiklikku eesmärki.
                </p>
              </div>
              
              <div className="bg-kaija-light p-6 rounded-lg shadow-sm">
                <h3 className="text-lg font-medium mb-2">Turvaline ja toetav ruum</h3>
                <p className="text-gray-700">
                  Loon usaldusväärse keskkonna, kus saad julgelt uurida oma mõtteid, tundeid ja võimalusi – hinnangutevabalt.
                </p>
              </div>
              
              <div className="bg-kaija-light p-6 rounded-lg shadow-sm">
                <h3 className="text-lg font-medium mb-2">Tõeline ja püsiv muutus</h3>
                <p className="text-gray-700">
                  Meie koostöö tulemusena koged sisulisi muutusi, mis peegelduvad nii enesetundes, igapäevaelus kui ka tööalastes valikutes.
                </p>
              </div>
            </div>
            
            <div className="mt-8">
              <Button asChild className="bg-kaija-slate hover:bg-opacity-90 text-white">
                <Link to="/contact">Alusta enda teekonda</Link>
              </Button>
            </div>
          </div>
          
          <div className="order-1 md:order-2">
            <img 
              src="/images/IMG_2884-1_resized-768x1024.jpg" 
              alt="Kaija Alliksaar" 
              className="rounded-lg shadow-md w-full"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ValuePropositionSection;
